<template>
  <div class="user-management">
    <div class="header">
      <h2>用户管理</h2>
      <div class="header-ops">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-form-item>
            <el-select v-model="searchForm.role" placeholder="筛选角色" clearable @change="handleSearch"
              style="width: 120px;">
              <el-option label="管理员" value="ADMIN"></el-option>
              <el-option label="企业用户" value="ENTERPRISE_USER"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input v-model="searchForm.keyword" placeholder="搜索用户名/手机号/邮箱" clearable @clear="handleSearch"
              @keyup.enter.native="handleSearch">
              <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button type="primary" icon="el-icon-plus" @click="handleAdd">创建用户</el-button>
      </div>
    </div>

    <!-- 用户列表表格 -->
    <el-table :data="users" v-loading="loading" border style="width: 100%">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="username" label="用户名" width="150"></el-table-column>
      <el-table-column prop="role" label="角色" width="120">
        <template slot-scope="scope">
          <el-tag :type="scope.row.role === 'ADMIN' ? 'danger' : 'primary'">
            {{ scope.row.role === 'ADMIN' ? '管理员' : '企业用户' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="enterpriseName" label="关联企业" min-width="200">
        <template slot-scope="scope">
          {{ scope.row.enterpriseName || '-' }}
        </template>
      </el-table-column>
      <el-table-column prop="email" label="邮箱" width="180"></el-table-column>
      <el-table-column prop="phone" label="手机号" width="130"></el-table-column>
      <el-table-column prop="status" label="状态" width="100">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status === 'ACTIVE' ? 'success' : 'info'">
            {{ scope.row.status === 'ACTIVE' ? '正常' : '停用' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页条 -->
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.page" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 创建用户对话框 -->
    <el-dialog title="创建用户" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="userForm" :rules="rules" ref="userForm" label-width="120px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="userForm.password" type="password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input v-model="userForm.confirmPassword" type="password" placeholder="请再次输入密码" show-password></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-radio-group v-model="userForm.role">
            <el-radio label="ADMIN">管理员</el-radio>
            <el-radio label="ENTERPRISE_USER">企业用户</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="关联企业" prop="enterpriseId" v-if="userForm.role === 'ENTERPRISE_USER'">
          <el-select v-model="userForm.enterpriseId" placeholder="请选择关联企业" style="width: 100%">
            <el-option v-for="enterprise in enterprises" :key="enterprise.id" :label="enterprise.name"
              :value="enterprise.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="userForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import api from '../../api/config'

export default {
  name: 'UserManagement',
  data() {
    const validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度不能少于6位'))
      } else {
        if (this.userForm.confirmPassword !== '') {
          this.$refs.userForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    const validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.userForm.password) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }

    return {
      users: [],
      enterprises: [],
      loading: false,
      dialogVisible: false,
      submitting: false,
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      searchForm: {
        keyword: '',
        role: ''
      },
      userForm: {
        username: '',
        password: '',
        confirmPassword: '',
        role: 'ENTERPRISE_USER',
        enterpriseId: null,
        email: '',
        phone: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 50, message: '用户名长度在 3 到 50 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        enterpriseId: [
          { required: true, message: '请选择关联企业', trigger: 'change' }
        ],
        email: [
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ],
        phone: [
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.loadUsers()
    this.loadEnterprises()
  },
  methods: {
    async loadUsers() {
      try {
        this.loading = true
        const params = {
          page: this.pagination.page,
          size: this.pagination.size,
          keyword: this.searchForm.keyword,
          role: this.searchForm.role
        }
        const response = await api.get('/admin/users', { params })
        if (response.success) {
          this.users = response.data || []
          this.pagination.total = response.total || 0
        } else {
          this.$message.error('加载用户列表失败: ' + (response.message || ''))
        }
      } catch (error) {
        console.error('加载用户列表失败:', error)
        this.$message.error('加载用户列表失败')
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.page = 1
      this.loadUsers()
    },
    resetSearch() {
      this.searchForm = {
        keyword: '',
        role: ''
      }
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.pagination.page = 1
      this.loadUsers()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.loadUsers()
    },
    async loadEnterprises() {
      try {
        const response = await api.get('/enterprises')
        this.enterprises = response.data || []
      } catch (error) {
        console.error('加载企业列表失败:', error)
      }
    },
    handleAdd() {
      this.dialogVisible = true
    },
    handleSubmit() {
      this.$refs.userForm.validate(async (valid) => {
        if (!valid) {
          return false
        }

        // 如果是管理员，清除企业ID
        const submitData = { ...this.userForm }
        if (submitData.role === 'ADMIN') {
          submitData.enterpriseId = null
        }
        delete submitData.confirmPassword

        try {
          this.submitting = true
          await api.post('/admin/users', submitData)
          this.$message.success('用户创建成功')
          this.dialogVisible = false
          this.loadUsers()
        } catch (error) {
          console.error('创建用户失败:', error)
        } finally {
          this.submitting = false
        }
      })
    },
    handleDialogClose() {
      this.$refs.userForm.resetFields()
      this.userForm = {
        username: '',
        password: '',
        confirmPassword: '',
        role: 'ENTERPRISE_USER',
        enterpriseId: null,
        email: '',
        phone: ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.user-management {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    h2 {
      margin: 0;
      font-size: 24px;
      color: #333;
    }

    .header-ops {
      display: flex;
      align-items: center;
      gap: 15px;

      .search-form {
        margin-bottom: 0;

        .el-form-item {
          margin-bottom: 0;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .user-management {
    .header {
      flex-direction: column;
      align-items: flex-start;
      gap: 15px;

      h2 {
        font-size: 20px;
      }

      button {
        width: 100%;
      }
    }
  }

  // 优化表格在移动端的显示
  ::v-deep .el-table {
    font-size: 12px;

    .el-table__header th,
    .el-table__body td {
      padding: 8px 5px;
    }

    .el-table__body-wrapper {
      overflow-x: auto;
    }
  }

  // 优化对话框在移动端的显示
  ::v-deep .el-dialog {
    width: 95% !important;
    margin-top: 5vh !important;
  }

  .pagination-container {
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
